const LOCKABLE_FIELDS = {
  greenhouse_intro: true,
  greenhouse_content_pay_transparency: true,
  greenhouse_conclusion: true,

  lever_description_template: true,
  lever_closing_template: true,

  workday_summary: true,
  workday_additional_description: true,

  successfactors_description_header: true,
  successfactors_description_footer: true,

  smartrecruiters_company_description: true,
  smartrecruiters_additional_information: true,

  ashby_compensation_statement: true,

  teamtailor_pitch: true,
};

export const isHeaderOrFooterField = (type = '') => type.endsWith('__header')
  || type.endsWith('__footer');

export const isFieldLockable = (type) => Boolean(LOCKABLE_FIELDS[type])
  || isHeaderOrFooterField(type);
